<template>
  <div class="capitulos">
    <VueSlickCarousel
      :dots="true"
      class="capitulos__carousel"
      :autoplay="true"
      :autoplaySpeed="5000"
      :arrows="false"
    >
      <div class="capitulos__hero capitulos__hero--1">
        <div class="left">
          <h1>
            Disfruta ya el sexto capítulo<br />
            <span>Shark Tank Colombia</span> <br />
            <span> presenta DiDi Lab.</span>
          </h1>
          <button @click="watchFromBanner">Ver capítulo</button>
        </div>
        <div></div>
      </div>
      <div class="capitulos__hero capitulos__hero--2">
        <div class="left">
          <h1>
            <span>Nuevos episodios</span>
            todos los viernes
          </h1>
        </div>
        <div></div>
      </div>
      <!-- <div class="capitulos__hero capitulos__hero--3">
        <div class="left"></div>
        <div></div>
      </div> -->
    </VueSlickCarousel>

    <!-- <div class="capitulos__hero capitulos__hero--1">
      <div class="left">
        <h1>
          Disfruta ya el primer capítulo<br />
          <span>Shark Tank Colombia</span> <br />
          <span> presenta DiDi Lab.</span>
        </h1>
      </div>
      <div></div>
    </div> -->

    <h2 class="capitulos__titulo">CAPÍTULOS</h2>

    <p class="capitulos__subtitulo">
      Shark Tank Colombia presenta DiDi Lab, un laboratorio de ideas para la
      reactivación del país. Vive esta experiencia de seis capítulos, que tendrá
      más dientes de los que esperas.
    </p>

    <div class="capitulos__container-capitulos">
      <ChapterCard 
        :watchVideo="watchVideo" 
        description="En el sexto episodio, los finalistas vivieron la emoción de presentar su proyecto ante el jurado. Vivieron momentos de tensión y al final los 50 millones se irán a casa con uno de ellos. ¡No te pierdas el capítulo final donde conoceremos al ganador de DiDi Lab!"
        id="tXcl0vLL5_M"
        img="video_cover_6.jpg"
        number="6"
      />
      <ChapterCard 
        :watchVideo="watchVideo" 
        description="Conoceremos en detalle los 2 emprendimientos finalistas, quienes ahora compiten entre sí. Además se preparan para el pitch frente a los tiburones, de la mano con los expertos en emprendimiento."
        id="xF6SHygG6R4"
        img="video_cover_5.jpg"
        number="5"
      />
      <ChapterCard 
        :watchVideo="watchVideo" 
        description="En este cuarto episodio los jurados darán los resultados del reto 3, la sumatoria final de los retos y con este resultado conocemos al equipo que pasará a la gran final y que se enfrentará uno contra el otro para pescar el tan esperado premio."
        id="E2z_dNShFg4"
        img="video_cover_4.jpg"
        number="4"
      />
      <ChapterCard 
        :watchVideo="watchVideo" 
        description="En este tercer episodio los equipos se enfrentan a la prueba definitiva, un reto que definirá su supervivencia en el tanque de DiDi Lab"
        id="E08ONDuQ3BM"
        img="video_cover_3.jpg"
        number="3"
      />
      <ChapterCard 
        :watchVideo="watchVideo" 
        description="Conoceremos al ganador del primer reto y los equipos se enfrentarán a un nuevo desafío que será más difícil de lo que esperan"
        id="UtMnCIuWkDs"
        img="video_cover_2.jpg"
        number="2"
      />
      <ChapterCard 
        :watchVideo="watchVideo"
        description="Los 3 equipos se enfrentan a su primer reto, poniendo a prueba su capacidad para identificar problemas. El primer pitch ante los jurados les pasará factura."
        id="Rg07rvqA9Uc"
        img="video_cover.jpg"
        number="1"
      />
    </div>
    <Allies />

    <VideoPlayer
      :show="showPlayer"
      :closePlayer="closePlayer"
      :id="currentVideo"
    />
  </div>
</template>

<script>
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import Allies from "@/components/Allies";
import ChapterCard from "@/components/ChapterCard";
import VideoPlayer from "@/components/VideoPlayer";

export default {
  components: { VueSlickCarousel, Allies, ChapterCard, VideoPlayer },
  data() {
    return {
      showPlayer: false,
      currentVideo: "",
      capitulos: [],
    };
  },
  methods: {
    closePlayer() {
      this.currentVideo = "";
      this.showPlayer = false;
    },
    watchVideo(vid) {
      this.currentVideo = vid;
      this.showPlayer = true;
    },
    watchFromBanner() {
      this.currentVideo = "tXcl0vLL5_M";
      this.showPlayer = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.capitulos {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: url("../assets/images/bg.jpg") no-repeat;
  background-size: cover;
  background-position-y: 45%;

  .slick-dots {
    bottom: 10px;
  }

  .slick-dots li button::before {
    color: white;
    font-size: 12px;
  }

  &__carousel {
    width: 100%;
  }

  &__hero {
    width: 100%;
    padding: 2rem 4rem;
    display: grid !important;
    height: 45vh;

    @include phone {
      padding: 1rem 2rem;
      height: 20vh;
    }

    &--1 {
      background: url("../assets/images/home/hero_1_2.jpg") no-repeat;
      background-size: cover;
      grid-template-columns: 40% 60%;

      @include phone {
        grid-template-columns: 60% 40%;
        background: url("../assets/images/home/hero_1_2.jpg") 50% 50% no-repeat;
        background-size: cover;
      }
    }
    &--2 {
      background: url("../assets/images/home/hero_2_2.jpg") no-repeat;
      background-size: cover;
      grid-template-columns: 50% 50%;

      @include phone {
        grid-template-columns: 80% 20%;
        background: url("../assets/images/home/hero_2_2.jpg") 50% 50% no-repeat;
        background-size: cover;
      }
    }
    &--3 {
      background: url("../assets/images/home/hero_3_2.jpg") no-repeat;
      background-size: cover;
      grid-template-columns: 60% 40%;

      @include phone {
        grid-template-columns: 80% 20%;
      }
    }

    .left {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      h1 {
        color: white;

        @include phone {
          font-size: 0.8rem;
          width: 100%;
        }

        span {
          font-weight: 100;
        }
      }
      button {
        background: #ff7d41;
        color: white;
        border-radius: 50px;
        padding: 0.5rem 1rem;
        align-self: flex-start;
      }
    }
  }

  &__titulo {
    margin: 3rem 0 2rem 0;
    color: white;

    @include phone {
      margin: 3rem 0 1rem 0;
    }
  }

  &__subtitulo {
    color: white;
    width: 45%;
    text-align: center;
    @include phone {
      width: 90%;
    }
  }

  &__container-capitulos {
    margin: 3rem 0;
    width: 70%;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;

    @include phone {
      grid-template-columns: 1fr;
    }
  }
}
</style>